var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_886_9484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_886_9484)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_886_9484",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 0,
    width: 48,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H-8V32H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_886_9484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 23.6541H-8V32H40V23.6541Z",
    fill: "#D60B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0H-8V15.392H40V0Z",
    fill: "#FAD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 15.3921H-8V23.6836H40V15.3921Z",
    fill: "#22408B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombia);
export default __webpack_public_path__ + "static/media/colombia.dbd386f592d10d0cc87f135555acfd96.svg";
export { ForwardRef as ReactComponent };